import { render, staticRenderFns } from "./surcharge.vue?vue&type=template&id=695fb4ae&scoped=true"
import script from "./surcharge.vue?vue&type=script&lang=js"
export * from "./surcharge.vue?vue&type=script&lang=js"
import style0 from "./surcharge.vue?vue&type=style&index=0&id=695fb4ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "695fb4ae",
  null
  
)

export default component.exports